import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiCall } from "../helper/axios";
// ✅ Async Thunk
export const fetchAccountPerformanceClientReport = createAsyncThunk("accountPerformanceClientReport/fetchReport", async (params, { getState, rejectWithValue }) => {
    try {
        const { auth } = getState();
        const token = auth?.token;
        const response = await ApiCall("POST", "/api/account-performance-client-report", params, {
            Authorization: token || "",
            modulekey: params.module_key
        });
        if (response && 'data' in response && response.data?.success) {
            return response.data;
        }
        if (response && response.isAxiosError) {
            const axiosErr = response;
            return rejectWithValue(axiosErr.response?.data?.message || "Failed to fetch account performance client report");
        }
        return rejectWithValue(response?.data?.message || "Failed to fetch account performance client report");
    }
    catch (error) {
        return rejectWithValue(error?.response?.data?.message ||
            error.message ||
            "An error occurred");
    }
});
// ✅ Initial State
const initialState = {
    data: null,
    loading: false,
    error: null,
};
// ✅ Slice
const accountPerformanceClientReportSlice = createSlice({
    name: "accountPerformanceClientReport",
    initialState,
    reducers: {
        clearAccountPerformanceClientReportData: (state) => {
            state.data = null;
            state.error = null;
        },
        clearAccountPerformanceClientReportError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAccountPerformanceClientReport.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchAccountPerformanceClientReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.data;
            state.error = null;
        })
            .addCase(fetchAccountPerformanceClientReport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Failed to fetch report";
        });
    },
});
// ✅ Actions
export const { clearAccountPerformanceClientReportData, clearAccountPerformanceClientReportError } = accountPerformanceClientReportSlice.actions;
// ✅ Selectors
export const selectAccountPerformanceClientReportData = (state) => state.accountPerformanceClientReport.data;
export const selectAccountPerformanceClientReportLoading = (state) => state.accountPerformanceClientReport.loading;
export const selectAccountPerformanceClientReportError = (state) => state.accountPerformanceClientReport.error;
export const selectAccountPerformanceClientReportLastUpdated = (state) => state.accountPerformanceClientReport.data?.last_updated ?? null;
export default accountPerformanceClientReportSlice.reducer;
